<template>
  <div>
     <!--start location picker modal -->
<div class="modal fade" id="LocationPickerModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="locationPickerLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-introduction rounded-3 padding-bottom-2">
      <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block padding-left-3 padding-right-3">
        <h1 class="text-black mb-0 medium-family float-start text-size-14 text-full-14">Select Location</h1>
        <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('LocationPickerModal')" aria-label="Close"></button>
      </div>
      <div class="modal-body padding-2 position-relative">
        <!-- Location Search Input -->
        <div class="w-100 d-inline-block margin-top-2 position-relative">
          <div class="row">
            <div class="col-xl-10 col-12">
               <form class="position-relative booking-banner" @submit.prevent>
                  <input
                    type="text"
                    v-model="searchQuery"
                    @input="handleInput"
                    placeholder="Search for area, street name, landmark..."
                    class="bg-white box-shadow rounded-3 border-0 text-size-16 text-full-13 w-100"
                  />
                  <a class="position-absolute location-icon" href="javascript:void(0)">
                    <img src="@/assets/images/location-service-icon.svg" alt="Location icon">
                  </a>
                  <i class="fa fa-angle-down position-absolute nav-color angle-right-icon" aria-hidden="true"></i>
              </form>
            </div>
            <div class="col-xl-2 col-12 mt-xl-0 mt-3 
            ps-xl-0">
              <div class="text-end margin-top-2">
                <button
                  type="button"
                  class="btn btn-success px-4 py-2 text-white text-size-14 rounded-3 text-full-14"
                  @click="confirmLocation"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
          <!-- Predictions Dropdown -->
          <div v-if="predictions.length" class="predictions-container position-absolute w-100 margin-top-1 z-3">
            <div 
              v-for="(suggestion, index) in predictions" 
              :key="index"
              class="prediction-item padding-2 text-start bg-white border-bottom cursor-pointer text-full-13 text-size-14"
              @click="selectSuggestion(suggestion)"
            >
              {{ suggestion.description }}
            </div>
          </div>
        </div>

        <!-- Map Section -->
        <!-- <div class="w-100 d-inline-block margin-top-3 rounded-3 overflow-hidden" style="height: 400px;">
          <div id="map" style="width: 100%; height: 100%;"></div>
        </div> -->
        <div class="w-100 d-inline-block margin-top-3 rounded-3 confirm-location-map customer-slider-map-wrap">
          <div id="map" class="customer-slider-map-el"></div>
           <div v-if="!locationConfirmed" class="position-absolute start-50 translate-middle text-center text-white bg-dark bg-opacity-75 rounded-2"
          style="width: 310px; top: 75%; padding: 0 1rem !important;">
            Move the map to set the exact position
          </div>
        </div>
        <div v-if="locationConfirmed" class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
          <div v-else class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block disabled"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
        <!-- Place the button right after the map div -->
      </div>
    </div>
  </div>
</div>
<!--end location picker modal -->
    <div class="testimonial-booking-section w-100 d-inline-block py-5 position-relative">
      <!-- Floating Pets -->
      <img v-lazy="require('@/assets/images/about-image-dog-2.png')" class="floating-pet pet-left-dog d-none d-xl-block" alt="dog">
      <!-- <img v-lazy="require('@/assets/images/about-image-cat-2.webp')" class="floating-pet pet-left-cat d-none d-xl-block" alt="cat"> -->
      <img v-lazy="require('@/assets/images/cute-cat-icon.png')" class="floating-pet pet-right-cat d-none d-xl-block" alt="gray cat">

      <div class="container autoContent position-relative z-1">
        <div class="testimonial-booking-card bg-white shadow-sm overflow-hidden">
          <div class="row g-0">
            <!-- Left: Testimonials -->
            <div class="col-xl-5 col-lg-5 col-12 p-4 p-md-5">
              <div class="testimonials-wrapper h-100 d-flex flex-column">
                <span class="text-uppercase text-size-12 fw-bold text-muted family-filson-bold tracking-wider mb-2">TESTIMONIALS</span>
                <h2 class="text-black fw-bold text-size-28 family-filson-bold mb-4">Our Happy Customers</h2>

                <div id="customerCarousel" class="carousel slide h-100" data-bs-ride="carousel">
                  <div class="carousel-inner h-100" :key="`reviews-${activeWebsiteName}-${reviews.length}`">
                    <div
                      v-for="(r, idx) in reviewsToRender"
                      :key="`review-${r.id || idx}`"
                      class="carousel-item"
                      :class="{ active: idx === 0 }"
                    >
                      <div class="quote-icon mb-4">
                        <svg width="45" height="40" viewBox="0 0 45 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.25 0V11.25H4.5V20.25H11.25V33.75H0V11.25L4.5 0H11.25ZM33.75 0V11.25H27V20.25H33.75V33.75H22.5V11.25L27 0H33.75Z" fill="none" stroke="#4878a6" stroke-width="2"/>
                        </svg>
                      </div>
                      <p class="text-black text-size-15 family-inter-light lh-lg mb-5">
                        {{ r.review }}
                      </p>
                      <div class="customer-profile d-flex align-items-center mt-auto">
                        <img
                          v-if="r.profile_img"
                          v-lazy="$getImageUrl(r.profile_img)"
                          class="rounded-circle me-3"
                          width="50"
                          height="50"
                          :alt="r.name"
                        >
                        <div
                          v-else
                          class="customer-initial-avatar me-3"
                          :style="{ backgroundColor: avatarBg(r.name) }"
                          :aria-label="r.name"
                          role="img"
                        >
                          {{ firstLetter(r.name) }}
                        </div>
                        <span class="text-size-14 fw-bold text-uppercase family-filson-bold blue-text">{{ r.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Dots (orange) -->
                <div v-if="reviewsToRender.length > 1" class="customer-carousel-indicators">
                  <button
                    v-for="(r, idx) in reviewsToRender"
                    :key="`dot-${r.id || idx}`"
                    type="button"
                    data-bs-target="#customerCarousel"
                    :data-bs-slide-to="idx"
                    :class="{ active: idx === 0 }"
                    :aria-current="idx === 0 ? 'true' : 'false'"
                    :aria-label="`Slide ${idx + 1}`"
                  ></button>
                </div>
              </div>
            </div>

            <!-- Right: Booking Form -->
            <div class="col-xl-7 col-lg-7 col-12 p-4 p-md-5">
              <div class="booking-form-wrapper">
                <h2 class="text-black fw-bold text-size-24 family-filson-bold mb-1">Book Mobile Pet Grooming at Your Doorstep</h2>
                <p class="text-size-13 text-muted mb-4 pb-2">Book Instantly for Mobile Grooming Services</p>

                <form @submit.prevent="submitBooking">
                  <div class="row g-3">
                    <div class="col-12">
                      <input v-model="formData.name" class="form-control modern-input" type="text" placeholder="Your Name" required />
                    </div>
                    
                    <div class="col-md-6">
                      <PhoneNumberInput v-model="formData.phoneNumber" @validation-changed="onPhoneValidationChanged" class="modern-phone-wrapper" />
                    </div>
                    <div class="col-md-6">
                      <input v-model="formData.email" class="form-control modern-input" type="email" placeholder="Enter your email (optional)"/>
                    </div>

                    <div class="col-md-6">
                      <multiselect
                        v-model="formData.selected_services"
                        :options="formattedServices"
                        :multiple="true"
                        :close-on-select="false"
                        placeholder="Select Services"
                        label="label"
                        track-by="id"
                        class="modern-select"
                      />
                    </div>
                    <div class="col-md-6">
                      <div class="position-relative">
                        <input
                          v-model="formData.date"
                          class="form-control modern-input ps-5 date-input-field"
                          type="date"
                          :min="minDate"
                          :max="maxDate"
                          required
                          @change="onDateChange"
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <textarea
                        v-model="formData.address"
                        class="form-control modern-input"
                        rows="4"
                        placeholder="Please enter your address with pin location"
                      ></textarea>
                    </div>

                    <div class="col-12 mt-4">
                      <div class="row align-items-center g-3">
                        <div class="col-md-4 col-12">
                          <button type="submit" :disabled="isSubmitting" class="btn btn-orange text-size-14 px-4 py-2 text-uppercase fw-bold rounded-1 shadow-sm w-100">
                            {{ isSubmitting ? 'Booking...' : 'SUBMIT NOW' }}
                          </button>
                        </div>
                        <div class="col-md-8 col-12">
                          <div class="d-flex align-items-center flex-md-nowrap flex-wrap gap-4 justify-content-md-start justify-content-center booking-contact-row">
                            <div class="d-flex align-items-center">
                              <div class="icon-circle me-2">
                                <img src="@/assets/images/calling-icon.svg" width="14" alt="phone">
                              </div>
                              <div class="lh-1">
                                <span class="d-block text-size-12 fw-bold text-black mb-1">Phone</span>
                                <span class="text-size-11 text-muted">+971 52573 5386</span>
                              </div>
                            </div>

                            <div class="d-flex align-items-center">
                              <div class="icon-circle me-2">
                                <img src="@/assets/images/clock-icon.svg" width="14" alt="timing">
                              </div>
                              <div class="lh-1">
                                <span class="d-block text-size-12 fw-bold text-black mb-1">Timing</span>
                                <span class="text-size-11 text-muted">9:00 AM - 10:00 PM</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setModalAccessibleOpen, setModalAccessibleClosed } from '@/utils/modalAria';
/* global google */
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PhoneNumberInput from '../PhoneNumberInput.vue';

export default {
  name: 'CustomerBookingForm',
  components: {
    Multiselect, 
    PhoneNumberInput
  },
  
  data() {
    const today = new Date();
    const todayString = today.toISOString().split('T')[0];
    return {
      locationConfirmed: false,
      date: todayString,
      predictions: [],
      timeSlots: [], 
      services: [],
      reviews: [],
      isSubmitting: false,
      todayDate: today,
      formData: {
        name: '',
        phoneNumber: '',
        email: '',
        selected_services: [],
        date: todayString, // Set today's date by default
        selectedSlot: null, // Will be set to first available slot
        pin_location: '',
        address: ''
      }
    };
  },
  computed: {
    reviewsToRender() {
      // Bootstrap carousel requires at least one item.
      if (Array.isArray(this.reviews) && this.reviews.length) return this.reviews;
      return [
        {
          id: 'fallback',
          name: 'Lush Groom Customer',
          review: 'We care for your pets like family. Add testimonials from the admin dashboard to show them here.',
          profile_img: null,
        },
      ];
    },
    // formattedServices() {
    //   return this.services.map(service => ({
    //     ...service,
    //     label: `${service.name}(${service.category_name} ${service.plan_name} Grooming) (AED ${service.price})`
    //   }));
    // },
    formattedServices() {
      return this.services.flatMap(group =>
        group.services.map(service => ({
          ...service,
          label: `${service.name} - ${service.plan_name} Grooming (AED ${service.price})`
        }))
      );
    },
    minDate() {
      return this.todayDate.toISOString().split('T')[0];
    },
    maxDate() {
      const max = new Date(this.todayDate);
      max.setDate(max.getDate() + 12);
      return max.toISOString().split('T')[0];
    },
    totalPrice() {
      return this.formData.selected_services.reduce((sum, service) => {
        let numericPrice = parseInt(String(service.price).replace(/\D/g, ''), 10);
        return sum + (isNaN(numericPrice) ? 0 : numericPrice);
      }, 0);
    }
  },
  mounted() {
    this.fetchServices();
    this.generateTimeSlots();
    this.fetchReviews();
  },
  methods: {
    firstLetter(name) {
      const s = String(name || '').trim();
      return (s[0] || 'U').toUpperCase();
    },
    avatarBg(name) {
      const palette = ['#F8721F', '#3B7197', '#6F42C1', '#198754', '#DC3545', '#0D6EFD', '#20C997', '#FD7E14'];
      const str = String(name || 'user');
      let hash = 0;
      for (let i = 0; i < str.length; i += 1) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
      }
      return palette[hash % palette.length];
    },
    async fetchReviews() {
      try {
        const res = await this.$axios.post('/get-reviews', {
          website_name: this.activeWebsiteName,
          limit: 10,
        });
        if (res.data && res.data.status === 'success') {
          this.reviews = Array.isArray(res.data.reviews) ? res.data.reviews : [];
        }
      } catch (e) {
        // Keep fallback testimonial if API fails
        console.error('get-reviews', e?.response || e);
      }
    },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion.description;
      this.address = suggestion.description;
      this.predictions = [];
    },
    confirmPinLocation() {
      if (this.lat && this.lng && this.address) {
        this.formData.pin_location = this.address;
        this.closeModal('LocationPickerModal');
        this.$toast && this.$toast.success('Location selected!');
      } else {
        this.$toast && this.$toast.error('Please select a location on the map.');
      }
    },
    confirmLocation() {
      this.formData.pin_location = this.searchQuery;
      this.closeModal('LocationPickerModal');
    },
    initMap() {
      this.openModal('LocationPickerModal');
      if (window.google && document.getElementById('map')) {
        const defaultLatLng = { lat: 25.2048, lng: 55.2708 };
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: defaultLatLng,
          zoom: 12,
        });
        this.marker = new google.maps.Marker({
          position: defaultLatLng,
          map: this.map,
          draggable: true,
        });

        this.marker.addListener('dragend', (event) => {
          this.locationConfirmed = true;
          this.lat = event.latLng.lat();
          this.lng = event.latLng.lng();
          this.reverseGeocodePin(this.lat, this.lng);
        });

        this.map.addListener('click', (event) => {
          this.marker.setPosition(event.latLng);
          this.lat = event.latLng.lat();
          this.lng = event.latLng.lng();
          this.reverseGeocodePin(this.lat, this.lng);
          this.locationConfirmed = true;
        });
        this.map.addListener('dragend', () => {
          const center = this.map.getCenter();
          this.marker.setPosition(center); // Optional: re-center the marker
          this.lat = center.lat();
          this.lng = center.lng();
          this.locationConfirmed = true;
          this.reverseGeocodePin(this.lat, this.lng);
        });
      }
    },
    async reverseGeocodePin(lat, lng) {
      const geocoder = new google.maps.Geocoder();
      const latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.address = results[0].formatted_address; 
          } else {
            console.error("No results found");
          }
        } else {
          console.error("Geocoder failed due to:", status);
        }
      });
    },
    openModal(id) {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        document.body.classList.add('modal-open');
        setModalAccessibleOpen(modalElement);
      }
    },
    closeModal(id) {
      const modalElement = document.getElementById(id);
      if (!modalElement) return;
      setModalAccessibleClosed(modalElement);
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');

      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
    },
    async handleInput() {
      if (this.searchQuery.trim().length > 1) {
        const result = await this.searchPlaces(this.searchQuery);
        if (result && result.predictions) {
          this.predictions = result.predictions;
        }
      } else {
        this.predictions = [];
      }
    },
    async searchPlaces(query) {
      try {
        const response = await this.$axios.post("/search-places", { query });
        return response.data;
      } catch (error) {
        console.error('Error fetching places:', error);
        return null;
      }
    },
    async fetchServices() {
      try {
        const response = await this.$axios.post('/booking-services', {
          website_name: this.activeWebsiteName
        });
        if (response.data.success) {
          this.services = response.data.services;
          // console.log('Services fetched on home page:', this.services);
        } else {
          this.$toast.error('Failed to load services');
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('Error fetching services');
      }
    },
    async generateTimeSlots() {
      try {
        const response = await this.$axios.post('/website-timing', {
          appointment_date: this.formData.date,
        });
        if (response.data.success) {
          this.timeSlots = response.data.all_slots.map(slot => ({
            time: slot,
            isAvailable: response.data.available_slots.includes(slot),
          }));
          
          // Auto-select first available slot if none is selected
          if (!this.formData.selectedSlot && this.timeSlots.length > 0) {
            const firstAvailableSlot = this.timeSlots.find(slot => slot.isAvailable);
            if (firstAvailableSlot) {
              this.formData.selectedSlot = firstAvailableSlot;
            }
          }
        } else {
          console.error('Error fetching slots:', response.data.message || 'Unknown error');
          this.timeSlots = [];
        }
      } catch (error) {
        console.error('Error fetching slots:', error);
        this.timeSlots = [];
      }
    },
    onDateChange() {
      // Reset selected slot when date changes
      this.formData.selectedSlot = null;
      this.generateTimeSlots();
    },
    openDatePicker() {
      this.$refs.dateInput.focus();
    },
    async submitBooking() {
      try {
        this.isSubmitting = true;
        const payload = {
          website_name: this.activeWebsiteName,
          name: this.formData.name,
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber,
          address: this.formData.address,
          pin_location: this.formData.pin_location,
          date: this.formData.date,
          duration_from: this.formData.selectedSlot.time.split('-')[0],
          duration_to: this.formData.selectedSlot.time.split('-')[1],
          service_ids: this.formData.selected_services.map(service => service.id),
          plan_detail_prices_ids: this.formData.selected_services.map(service => service.id),
          item_counts: this.formData.selected_services.map(service => ({ id: service.id, count: 1 })),
          totalPrice: this.totalPrice
        };
        const response = await this.$axios.post('/save-booking', payload);
        this.isSubmitting = false;
        if (response.data.success) {
          this.$toast.success('Booking submitted successfully!');
          const today = new Date().toISOString().split('T')[0];
          this.formData = {
            name: '',
            email: '',
            phoneNumber: '',
            address: '',
            pin_location: '',
            date: today,
            selected_services: [],
            selectedSlot: null
          };
          this.totalPrice = 0;

          // Re-fetch slots for today and auto-select first available
          this.generateTimeSlots();
        } else {
          this.$toast.error('Submission failed');
        }
      } catch (err) {
        this.isSubmitting = false;
        console.error(err);
        this.$toast.error('Error submitting booking');
      }
    },
    onPhoneValidationChanged(isValid) {
      // Handle phone validation if needed
      this.isPhoneValid = isValid;
    }
  }
};
</script>
<style scoped>
.testimonial-booking-section {
  background-color: #FFF2E6; /* Light Peach */
}

.testimonial-booking-card {
  border-radius: 40px;
  max-width: 1100px;
  margin: 0 auto;
}

.tracking-wider {
  letter-spacing: 0.1em;
}
.blue-text {
  color: #3B7197;
}

.customer-initial-avatar {
  width: 50px;
  height: 50px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  letter-spacing: 0.5px;
  font-family: inherit;
  flex: 0 0 auto;
}

.customer-carousel-indicators {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  width: 100%;
}

.customer-carousel-indicators button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background-color: rgba(248, 114, 31, 0.35);
  opacity: 1;
  border: 0;
  padding: 0;
}

.customer-carousel-indicators .active {
  background-color: #F8721F;
}

/* Keep phone + timing inline on md+ */
@media (min-width: 768px) {
  .booking-contact-row {
    flex-wrap: nowrap !important;
  }
}
.modern-input, .modern-select :deep(.multiselect__tags), .modern-phone-wrapper :deep(input) {
  background-color: #FDFAF5 !important;
  border: 1px solid #EBEBEB !important;
  border-radius: 8px !important;
  padding: 12px 15px;
  font-size: 14px;
}

.modern-input::placeholder {
  color: #cbbbae !important;
}

.modern-input:focus {
  border-color: #FD7E14 !important;
  box-shadow: none;
}

.date-input-field::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}

.ps-5 {
  padding-left: 45px !important;
}

.btn-orange {
  background-color: #FD7E14;
  color: white;
  border: none;
  transition: all 0.3s ease;
}

.btn-orange:hover {
  background-color: #E86B00;
  transform: translateY(-2px);
  color: white;
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Floating Pets */
.floating-pet {
  position: absolute;
  z-index: 0;
  pointer-events: none;
}

.pet-left-dog {
  bottom: 0px;
  left: 1%;
  width: 200px;
}

.pet-left-cat {
  bottom: 10px;
  left: 15%;
  width: 100px;
}

.pet-right-cat {
  bottom: 0px;
  right: 7%;
  width: 180px;
}

@media (max-width: 991.98px) {
  .testimonial-booking-card {
    border-radius: 20px;
  }
  .border-end {
    border-right: none !important;
    border-bottom: 2px solid #F8F9FA;
  }
}

.customer-slider-map-wrap {
  position: relative;
  overflow: visible;
}
.customer-slider-map-el {
  width: 100%;
  height: 100%;
  min-height: 280px;
}
</style>
